import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import { jsx } from 'react/jsx-runtime';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { forwardRef, useEffect, useCallback } from 'react';
import { MenuItemSideContent, MenuItemMainContent } from '../../util-components/menu-item-sections/menu-item-sections.js';
import { composeEventHandlers } from '../../utils/composeEventHandlers.js';
import { useForkRef } from '../../utils/useForkRef.js';
import { useSubMenuFocus } from '../../utils/useSubMenuFocus.hook.js';
import { useFullScreenDropdownMenu } from '../menu-utils/responsiveness/FullScreenDropdownMenuContext.js';
import { useResponsiveSubmenuContext } from './dropdown-menu-sub-menu-root.js';
import styles from './dropdown-menu.module.js';
var DropdownMenuSubMenuTriggerRoot = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var _useSubMenuFocus = useSubMenuFocus(),
      _useSubMenuFocus2 = _slicedToArray(_useSubMenuFocus, 2),
      localRef = _useSubMenuFocus2[0],
      setRefFocusNoop = _useSubMenuFocus2[1];

  var _useResponsiveSubmenu = useResponsiveSubmenuContext(),
      open = _useResponsiveSubmenu.open;

  var _useFullScreenDropdow = useFullScreenDropdownMenu(),
      isMenuFullScreenEnabled = _useFullScreenDropdow.isMenuFullScreenEnabled;

  useEffect(function () {
    if (!open) {
      var _localRef$current;

      (_localRef$current = localRef.current) === null || _localRef$current === void 0 ? void 0 : _localRef$current.focus();
    }
  }, [localRef, open]);
  var handleOnPointerMove = useCallback(function (e) {
    setRefFocusNoop(); //  we should call prevent default so hover doesn't trigger submenu, which is confusing on full screen.

    if (isMenuFullScreenEnabled) {
      e.preventDefault();
    }
  }, [isMenuFullScreenEnabled, setRefFocusNoop]);
  return jsx(DropdownMenuPrimitive.SubTrigger, _objectSpread(_objectSpread({}, rest), {}, {
    ref: useForkRef(localRef, forwardedRef),
    className: styles.item,
    onPointerMove: composeEventHandlers(props.onPointerMove, handleOnPointerMove),
    children: children
  }));
});
/**
 * Based on Radix-UI Sub Trigger
 * @see https://www.radix-ui.com/docs/primitives/components/dropdown-menu#subtrigger
 */

var DropdownMenuSubMenuTrigger = Object.assign(DropdownMenuSubMenuTriggerRoot, {
  /**
   * Container for side content of sub trigger.
   */
  SideContent: MenuItemSideContent,

  /**
   * Text content of sub trigger.
   */
  MainContent: MenuItemMainContent
});
export { DropdownMenuSubMenuTrigger };